import {useState, useEffect, FunctionComponent} from 'react';
import Grid from '@mui/material/Grid2'

import localAuth from 'model/auth/AuthStore';
import { BACKEND_ENDPOINT } from "../utils/Common";

import { Stack, Container, Typography } from "@mui/material";

import CollectionList from 'components/collection/CollectionList';
import { Loading } from 'components/common/Loading';
import { REMINDER } from 'assets/Icons'
import { useApi } from 'hooks/useApi';
import { CollectionModel } from 'model/collection/CollectionModels';
import { ErrorContainer } from 'components/common/ErrorContainer';

// TODO: do the same thing as the wizard with the loading
const Collections: FunctionComponent = () => {
  const { request, loading, error } = useApi();
  const accessToken: string = localAuth((state) => state.authToken);

  const [collections, setCollections] = useState([]);

  useEffect(() => {
    const loadCollections = async () => {
      try {
        const data = await request<CollectionModel[]>(() => 
          fetch(BACKEND_ENDPOINT + "collecting", {
            headers: {
              'Content-Type': 'application/json', 
              'Accept': 'application/json', 
              'Authorization': `Bearer ${accessToken}`
            }
          })
        );
        setCollections(data);
      } catch (error) {
        console.error("Failed to fetch collections:", error);
      }
    };
    
    loadCollections();
  }, [accessToken]);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Stack spacing={1}>
          <Loading toolbarLoading={<div style={{paddingLeft: "16px", paddingTop: "20px"}}>
            <Grid container>
              <Grid display="flex" alignItems="center">
                <Typography variant='h6'>
                  {REMINDER(20, {marginBottom: "-2px", marginRight: "10px"})}
                  COLLECTIONS
                </Typography>
              </Grid>
              <Grid size="grow"></Grid>
            </Grid></div>} variant='walker' height='71.33px'/>
          <Loading variant='walker' height='390px'/>
        </Stack>
      </Container>
    )
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Stack spacing={1}>
          <ErrorContainer errorToolbar={<div style={{paddingLeft: "16px", paddingTop: "20px"}}>
            <Grid container>
              <Grid display="flex" alignItems="center">
                <Typography variant='h6'>
                  {REMINDER(20, {marginBottom: "-2px", marginRight: "10px"})}
                  COLLECTIONS
                </Typography>
              </Grid>
              <Grid size="grow"></Grid>
            </Grid></div>} height='71.33px'/>
          <ErrorContainer text='An error occured while trying to fetch the collections. Please try again later.' height='390px'/>
        </Stack>
      </Container>
    )
  }

  return (
    <Container maxWidth="md">
      <CollectionList collections={collections}/>
    </Container>
  );
}
export default Collections;